import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page34',
  templateUrl: './page34.component.html',
  styleUrls: ['./page34.component.css']
})
export class Page34Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
